import { GraphMutationBuilderPayload, createMutation } from '@camelot/server';

import { invoiceProps } from './dto/invoice';

export function READ_INVOICE(id: string): GraphMutationBuilderPayload {
  return createMutation('invoiceRead', {
    argument: 'invoiceId',
    props: `
      ${invoiceProps.get('id')}
      ${invoiceProps.get('isNew')}
    `,
    type: 'UUID!',
    value: id,
  });
}
